// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__oawG7","upload":"Small_upload__3x7qH","imageWrap":"Small_imageWrap__28hBM","removeBtn":"Small_removeBtn__2FPZH"};